import React from "react";
import $ from "jquery";
import { Helmet } from "react-helmet";

export default function PrivacyPolicyGenerator() {
  <Helmet>
    <link rel="canonical" href={window.location.href} />
    <title>Privacy Policy Generator || Tamizhtechie</title>
    <meta
      property="description"
      content="Free privacy policy generator by Tamizhtechie"
    />
    <meta
      name="keywords"
      content="privacypolicygenerator, privacy policy, privacypolicy, generator, free online tools, privacy, free privacy policy generator, app privacy policy generator, privacy policy generator"
    />
    <meta
      property="og:title"
      content="Privacy Policy Generator || Tamizhtechie"
    />
    <meta
      property="og:description"
      content="Free privacy policy generator by Tamizhtechie"
    />
    <meta property="og:image:width" content="300" />
    <meta property="og:image:height" content="300" />
    <meta
      property="fb:app_id"
      content="https://www.facebook.com/tamizhtechie123"
    />

    <meta
      name="twitter:title"
      content="Privacy Policy Generator || Tamizhtechie"
    />
  </Helmet>;

  const shoot = () => {
    const companyName = document.querySelector("#companyName").value;
    const websiteUrl = document.querySelector("#websiteUrl").value;
    const emailId = document.querySelector("#emailId").value;
    const validDate = document.querySelector("#validDate").value;

    console.log(companyName);

    if (companyName == "" && websiteUrl == "" && emailId == "") {
      alert("Please Enter values");
    } else {
      const markupContainer = document.querySelector(
        ".generator__markup-generated"
      );

      const markup = `
  <div>

  <h2>Privacy Policy for <b>${companyName}</b></h2> <h4>Last Updated at: ${validDate}</h4> <p>At <b>${companyName}</b>, accessible from  <b>${websiteUrl} </b>, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by ${companyName} and how we use it.</p><p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to Contact through email at <b>${emailId}</b></p> <h2>Log Files</h2> <p> <b>${companyName}</b> follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users movement on the website, and gathering demographic information.</p><h2>Cookies and Web Beacons</h2><p>Like any other website, <b>${companyName}</b> uses cookies. These cookies are used to store information including visitors preferences and the pages on the website that the visitor accessed or visited. The information is used to optimize the users experience by customizing our web page content based on visitors browser type and/or other information.</p><h2>Google DoubleClick DART Cookie</h2><p>Google is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to serve ads to our site visitors based upon their visit to www.website.com and other sites on the internet. However, visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy Policy at the following URL &#8211; <a href="https://policies.google.com/technologies/ads">https://policies.google.com/technologies/ads</a></p><h2>Privacy Policies</h2><P>You may consult this list to find the Privacy Policy for each of the advertising partners of <b>${companyName}</b>.</p><p>Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on <b>${companyName}</b>, which are sent directly to usersbrowser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.</p><p>Note that <b>${companyName}</b> has no access to or control over these cookies that are used by third-party advertisers.</p><h2>Third Pary Privacy Policies</h2><p><b>${companyName}</b> s Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. You may find a complete list of these Privacy Policies and their links here: Privacy Policy Links.</p><p>You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers respective websites. What Are Cookies?</p><h2>Children s Information</h2><p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p><p><b>${companyName}</b> does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to Contact immediately and we will do our best efforts to promptly remove such information from our records.</p><h2>Online Privacy Policy Only</h2><p>This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in <b>${companyName}</b>. This policy is not applicable to any information collected offline or via channels other than this website.</p><h2>Consent</h2><p>By using our website, you hereby consent to our Privacy Policy and agree to its Terms and Conditions.</p>

  </div>
      `;

      markupContainer.textContent = markup;
    }
  };

  function copyToClipboard(element) {
    alert("");
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text()).select();
    document.execCommand("copy");
    $temp.remove();
  }

  return (
    <div>
      <div class="policygenerator">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h1 class="title">Free Privacy policy generator</h1>
            </div>
          </div>

          <div class="row">
            <div className="col-md-4">{/* Advertisnment */}</div>

            <div class="col-md-4 borders p-4">
              <div class="generator__questions">
                <label>Company Name:</label>&nbsp;
                <input
                  class="form-control"
                  id="companyName"
                  type="text"
                  required
                />
              </div>

              <div class="generator__questions">
                <label>Website Url:</label>
                <input
                  class="form-control"
                  required
                  id="websiteUrl"
                  type="text"
                />
              </div>

              <div class="generator__questions">
                <label>Emali Id:</label>
                <input
                  required
                  id="emailId"
                  placeholder=""
                  class="form-control"
                  type="text"
                />
              </div>

              <div class="generator__questions">
                <label>Date</label>
                <input
                  required
                  id="validDate"
                  placeholder=""
                  class="form-control"
                  type="date"
                />
              </div>

              <div class="generator__questions mt-3">
                <button class="generate-markup btn-primary btn" onClick={shoot}>
                  Generate Code
                </button>
              </div>
            </div>
            <div className="col-md-4">{/* Advertisnment */}</div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="generator__markup mt-5">
                <h3>Copy Your Page</h3>
                <pre>
                  <div className="text-center"></div>
                  <p id="p2">
                    <code class="generator__markup-generated"></code>
                  </p>
                  <div className="text-center"></div>
                </pre>
                {/* <button
                  class="btn btn-primary"
                  onclick={() => {
                    navigator.clipboard.writeText("#p2");
                  }}
                >
                  Click To Copy
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
